import type { OICPGatewayCommunication } from './oicp-gateway.interface';
import { normalizeEmi3Identifier } from './oicp.util';

const containsUnknownEvseText = (value: string | undefined): boolean =>
  typeof value === 'string' &&
  /(unknown\s+evse|evse\s+not\s+found)/i.test(value);

export const OICP_CPO_EVSE_STATUS_RECOVERY_QUEUE =
  'oicp-cpo-evse-status-recovery';

export const OICP_CPO_EVSE_STATUS_RECOVERY_DELAY_MS = 30 * 60 * 1000;
export const OICP_CPO_EVSE_STATUS_RECOVERY_PENDING_TTL_MS =
  OICP_CPO_EVSE_STATUS_RECOVERY_DELAY_MS + 5 * 60 * 1000;

export interface OicpCpoEvseStatusRecoveryRequest {
  operatorId: string;
  evseId: string;
  evseStatus?: string;
  correlationId?: string;
  requestedAtMs: number;
  sourceAction: OICPGatewayCommunication.Cpo.CommandAction;
  statusCode: OICPGatewayCommunication.StatusCode;
}

const normalizeRecoveryOperatorId = (operatorId: string): string =>
  normalizeEmi3Identifier(operatorId) ?? operatorId.trim();

export const buildOicpCpoEvseStatusRecoveryDedupeKey = (
  operatorId: string,
  evseId: string,
): string => `${normalizeRecoveryOperatorId(operatorId)}:${evseId.trim().toUpperCase()}`;

export const buildOicpCpoEvseStatusRecoveryBatchDedupeKey = (
  operatorId: string,
): string => `${normalizeRecoveryOperatorId(operatorId)}:full-load`;

export const isOicpUnknownEvseStatusCode = (
  statusCode:
    | Partial<OICPGatewayCommunication.StatusCode>
    | null
    | undefined,
): boolean => {
  if (!statusCode) {
    return false;
  }

  const code =
    typeof statusCode.Code === 'string' ? statusCode.Code.trim() : undefined;
  if (code === '603') {
    return true;
  }

  return (
    containsUnknownEvseText(
      typeof statusCode.Description === 'string'
        ? statusCode.Description
        : undefined,
    ) ||
    containsUnknownEvseText(
      typeof statusCode.AdditionalInfo === 'string'
        ? statusCode.AdditionalInfo
        : undefined,
    )
  );
};
